import type { components } from './_api'

export const TICKET_CHANNELS = ['amili', 'min_betalning', 'backoffice', 'tech_ops', 'legal', 'settlement'] as const

export type TicketChannel = (typeof TICKET_CHANNELS)[number]

/** Channels that carry conversations with debtors (Mitt Amili). settlement holds
 *  refund/rebooking tickets handed over from min_betalning, so it shares the
 *  min_betalning-specific behaviour (case note on reply, auto-reply filtering). */
export const DEBTOR_TICKET_CHANNELS = ['min_betalning', 'settlement'] as const satisfies readonly TicketChannel[]

/** Locale keys for the human-readable title of each ticket channel. Shared by
 *  the Tickets list view and the ticket details panel so the channel renders
 *  consistently (translated, not the raw enum value). */
export const TICKET_CHANNEL_TITLES: Record<TicketChannel, string> = {
  amili: 'common.tickets_invoice_control',
  min_betalning: 'common.tickets_min_betalning',
  backoffice: 'common.tickets_backoffice',
  tech_ops: 'common.tickets_tech_ops',
  legal: 'common.tickets_legal',
  settlement: 'common.tickets_settlement',
}

export type TicketChannelSettings = NonNullable<
  NonNullable<NonNullable<components['schemas']['User-Settings']['settings']['tickets']>['by_channel']>[TicketChannel]
>
